import { RouterProvider } from 'react-router-dom';
import { AuthProvider } from '@/core/auth/AuthProvider';
import { ThemeProvider } from '@/core/theme/ThemeProvider';
import { NotificationProvider } from '@/core/context/NotificationContext';
import { ToastProvider } from '@/shared/components/ui/use-toast';
import Toaster from '@/shared/components/ui/toaster';
import { router } from './router';

function App() {
  return (
    <ThemeProvider>
      <NotificationProvider>
        <ToastProvider>
          <AuthProvider>
            <RouterProvider router={router} />
          </AuthProvider>
          <Toaster />
        </ToastProvider>
      </NotificationProvider>
    </ThemeProvider>
  );
}

export default App;
